// import React, { useEffect, useState } from "react";
// import TicketTable from "../../../components/support/TicketTable";
// import TicketFilters from "../../../components/support/TicketFilters";
// import { supportTicketService } from "../../../services/supportTicketService";
// import type { SupportTicket } from "../../../types/supportTicket";
// import "../../../assets/adminSupportTickets.css";

// const AdminSupportTickets: React.FC = () => {
//   const [tickets, setTickets] = useState<SupportTicket[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [filters, setFilters] = useState({
//     search: "",
//     status: "",
//     priority: "",
//     department: "",
//   });

//   const fetchTickets = async () => {
//     try {
//       setLoading(true);
//       const res = await supportTicketService.getAdminTickets({
//         page: 1,
//         limit: 10,
//         ...filters,
//       });
//       setTickets(res.tickets || []);
//     } catch (error) {
//       console.error("Failed to fetch admin tickets", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTickets();
//   }, [filters]);

//   const handleChange = (key: string, value: string) => {
//     setFilters((prev) => ({ ...prev, [key]: value }));
//   };

//   const handleReset = () => {
//     setFilters({
//       search: "",
//       status: "",
//       priority: "",
//       department: "",
//     });
//   };

//   return (
//     <div className="admin-ticket-page">
//       <div className="support-card">
//         <div className="support-card-header">
//           <h2>
//             <i className="fa fa-life-ring" /> Admin Support Tickets
//           </h2>
//         </div>

//         <TicketFilters
//           filters={filters}
//           onChange={handleChange}
//           onReset={handleReset}
//         />

//         {loading ? (
//           <div className="ticket-empty-box">Loading tickets...</div>
//         ) : (
//           <TicketTable
//             tickets={tickets}
//             detailBasePath="/admin/support-tickets"
//             showSubscriber
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default AdminSupportTickets;

import React, { useEffect, useState } from "react";
import TicketTable from "../../../components/support/TicketTable";
import TicketFilters from "../../../components/support/TicketFilters";
import { supportTicketService } from "../../../services/supportTicketService";
import type { SupportTicket } from "../../../types/supportTicket";
import "../../../assets/adminSupportTickets.css";

const AdminSupportTickets: React.FC = () => {
  const [tickets, setTickets] = useState<SupportTicket[]>([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    priority: "",
    department: "",
  });

  const fetchTickets = async () => {
    try {
      setLoading(true);
      const res = await supportTicketService.getAdminTickets({
        page: 1,
        limit: 10,
        ...filters,
      });

      setTickets(res.tickets || []);
    } catch (error) {
      console.error("Failed to fetch admin tickets", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, [filters]);

  const handleChange = (key: string, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleReset = () => {
    setFilters({
      search: "",
      status: "",
      priority: "",
      department: "",
    });
  };

  const getValue = (ticket: any, keys: string[], fallback = "-") => {
    for (const key of keys) {
      if (
        ticket?.[key] !== undefined &&
        ticket?.[key] !== null &&
        ticket?.[key] !== ""
      ) {
        return ticket[key];
      }
    }
    return fallback;
  };

  return (
    <div className="admin-ticket-page">
      <div className="support-card admin-ticket-card">
        <div className="support-card-header admin-ticket-card-header">
          <h2>
            <i className="fa fa-life-ring" /> Admin Support Tickets
          </h2>
        </div>

        <TicketFilters
          filters={filters}
          onChange={handleChange}
          onReset={handleReset}
        />

        {loading ? (
          <div className="ticket-empty-box">Loading tickets...</div>
        ) : (
          <>
            <div className="admin-ticket-desktop-table">
              <TicketTable
                tickets={tickets}
                detailBasePath="/admin/support-tickets"
                showSubscriber
              />
            </div>

            <div className="admin-ticket-mobile-grid">
              {tickets.length === 0 ? (
                <div className="ticket-empty-box">No tickets found.</div>
              ) : (
                tickets.map((ticket: any) => {
                  const id = getValue(ticket, ["id", "ticket_id"]);
                  const ticketNo = getValue(ticket, [
                    "ticket_no",
                    "ticketNo",
                    "ticketNumber",
                    "ticket_number",
                  ]);
                  const subject = getValue(ticket, ["subject", "CoSubject"]);
                  const department = getValue(ticket, [
                    "department",
                    "CoDepartment",
                  ]);
                  const status = getValue(ticket, ["status", "ticket_status"]);
                  const priority = getValue(ticket, ["priority"]);
                  const subscriber = getValue(ticket, [
                    "subscriber_name",
                    "subscriberName",
                    "name",
                    "customerName",
                  ]);
                  const email = getValue(ticket, [
                    "subscriber_email",
                    "subscriberEmail",
                    "email",
                    "customerEmail",
                  ]);

                  return (
                    <div className="admin-ticket-mobile-card" key={id}>
                      <div className="admin-ticket-mobile-top">
                        <h3>{subject}</h3>
                        <span className="admin-ticket-status">
                          {String(status)}
                        </span>
                      </div>

                      <p className="admin-ticket-key">
                        <strong>{ticketNo}</strong>
                      </p>

                      <div className="admin-ticket-mobile-info">
                        <p>
                          <strong>{department}</strong>
                        </p>

                        <p>
                          Priority:
                          <strong>{priority}</strong>
                        </p>

                        <p>
                          <span>Subscriber:</span>
                          <strong>{subscriber}</strong>
                        </p>

                        <p>
                          <strong>{email}</strong>
                        </p>
                      </div>

                      <a
                        href={`/admin/support-tickets/${id}`}
                        className="admin-ticket-view-btn"
                      >
                        View
                      </a>
                    </div>
                  );
                })
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminSupportTickets;
